"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMeetingsLinks = fetchMeetingsLinks;
exports.fetchMeetingsUser = fetchMeetingsUser;
exports.updateMeetingDetails = updateMeetingDetails;

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var MeetingsAPI = _interopRequireWildcard(require("./api/MeetingsAPI"));

var pendingUserFetch = null;
var pendingLinksFetch = null;

function fetchMeetingsLinks() {
  if (!pendingLinksFetch) {
    pendingLinksFetch = MeetingsAPI.fetchMeetingsLinks().then(function (links) {
      (0, _Dispatch.dispatchImmediate)(_ActionTypes.MEETINGS_LINKS_FETCH_SUCCEEDED, links);
      return links;
    }).catch(function (error) {
      (0, _Dispatch.dispatchImmediate)(_ActionTypes.MEETINGS_LINKS_FETCH_FAILED);

      if (error.status !== 404) {
        throw error;
      }
    }).finally(function () {
      pendingLinksFetch = null;
    });
  }

  return pendingLinksFetch;
}

function fetchMeetingsUser() {
  if (!pendingUserFetch) {
    pendingUserFetch = MeetingsAPI.fetchMeetingsUser().then(function (user) {
      (0, _Dispatch.dispatchImmediate)(_ActionTypes.MEETINGS_USER_FETCH_SUCCEEDED, user);
      return user;
    }).catch(function () {
      return (0, _Dispatch.dispatchImmediate)(_ActionTypes.MEETINGS_USER_UNAVAILABLE);
    }).finally(function () {
      pendingUserFetch = null;
    });
  }

  return pendingUserFetch;
}

function updateMeetingDetails(meeting) {
  (0, _Dispatch.dispatchImmediate)(_ActionTypes.MEETING_DETAILS_UPDATED, meeting);
}